angular.module('env.data.rest.restProvider', [])

    .provider('rest', function (modelFactoryProvider) {

        var defaultConfig = getDefaultConfig();

        function getDefaultConfig() {
            var cfg = new RestConfigurator();

            // some defaults here

            return cfg;
        }

        /**
         * Helper for Rest service initialisation
         * @constructor
         */
        function RestConfigurator() {
            var config = this;

            /**
             * The base URL for all calls to your API
             * @param {string} baseUrl url without leading or trailing slashes
             */
            config.setBaseUrl = function (baseUrl) {
                config.baseUrl = baseUrl;
            };

            /**
             * Request suffix for all calls to your API
             * @param {string} requestSuffix suffix without trailing or leading slashes
             */
            config.setRequestSuffix = function (requestSuffix) {
                config.requestSuffix = requestSuffix;
            };

            /**
             * Hash of default headers for all calls to your API
             * @param {Object.<string|Object>} defaultHeaders default headers hash
             */
            config.setDefaultHeaders = function (defaultHeaders) {
                config.defaultHeaders = defaultHeaders;
            };

            /**
             * Hash of default request params for all calls to your API
             * @param {Object.<string|Object>} defaultParams hash of default request params
             */
            config.setDefaultParams = function (defaultParams) {
                config.defaultParams = defaultParams;
            };

            /**
             * Default config for $http service
             * @param {Object.<string|Object>} defaultHttpConfig default config for $http service
             */
            config.setDefaultHttpConfig = function (defaultHttpConfig) {
                config.defaultHttpConfig = defaultHttpConfig;
            };
        }

        /**
         * Define model
         * @param {string} name name of the model
         * @param {*} config configuration
         */
        function defineModel(name, config) {
            modelFactoryProvider.define(name, config);
        }

        _.extend(this, {
            defaultConfig: defaultConfig,
            defineModel: defineModel
        });

        this.$get = function (RestService, modelPool) {

            /**
             * Get new instance of RestService with custom config
             * @param {Function} [configFunction] configuration function that takes RestConfigurator as argument
             * @returns {RestService}
             */
            function makeAnotherInstance(configFunction) {
                var configurator = _.clone(defaultConfig);
                if (configFunction) {
                    configFunction(configurator);
                }
                return new RestService(configurator, modelPool);
            }

            return _.extend(makeAnotherInstance(), {
                makeAnotherInstance: makeAnotherInstance
            });
        }
    })

    .factory('RestService', function ($q, $log, $http, $injector, modelFactory, EventingMixin, RepresentationModel, ModelDefinition) {
        /**
         * Rest service
         * @param {RestConfigurator} configurator Configurator of Rest Service
         * @param {ModelPoolService} pool model pool instance
         * @constructor
         */
        function RestService(configurator, pool) {
            var _this = this;

            _.extend(_this, new EventingMixin([
                "modelUpdated",
                "modelUpdatedOnServer",
                "modelCreatedOnServer"
            ]));

            /**
             * @type {RestConfigurator}
             */
            var config = configurator;
            /**
             * @type {ModelPoolService}
             */
            var modelPool = pool;

            /**
             * Request mapper. Contains information about request and execute it
             * @param {Array|string} [parts] parts of the url
             * @constructor
             */
            function RestMapper(parts) {
                var _mapper = this;
                var path = path || [];
                var futureId;
                var futureType;

                //region Mapping

                map(parts);

                /**
                 * Map request
                 * @returns {RestService.RestMapper}
                 */
                function map() {
                    _.forEach(arguments, function (urlPart) {
                        if (!urlPart) {
                            // do nothing, return mapper
                        } else if (_.isString(urlPart)) {
                            _addUrlPart(urlPart);
                        } else if (_.isNumber(urlPart)) {
                            _addUrlPart(urlPart.toString());
                        } else if (urlPart.isRepresentationModel) {
                            //map(urlPart.getDefinition().getUrl());
                            map(urlPart.getId());
                        } else if (urlPart instanceof ModelDefinition) {
                            map(urlPart.getUrl());
                        } else if (_.isArray(urlPart) || _.isArguments(urlPart)) {
                            _.forEach(urlPart, function (_urlPart) {
                                map(_urlPart);
                            });
                        } else if (_.isFunction(urlPart.toString)) {
                            map(urlPart.toString());
                        } else {
                            throw new Error("Can't construct route");
                        }
                    });
                    return _mapper;
                }

                function _addUrlPart(urlPart) {
                    path.push(urlPart);
                }

                /**
                 * Add information about objects that will be returned (for cache service)
                 * @param {string|ModelDefinition} modelType type of the returned model
                 * @param {string|Number} [modelId] id of the model. This id will be promised to cache service.
                 * @returns {RestService.RestMapper}
                 */
                function willReturn(modelType, modelId) {
                    if (modelType) {
                        if (_.isString(modelType)) {
                            futureType = modelType;
                        } else {
                            futureType = modelType.getType();
                        }
                    }
                    if (modelId) {
                        futureId = modelId;
                    }
                    return _mapper;
                }

                //endregion

                //region HTTP public interface

                function ensureCache(func) {
                    if (futureId && futureType && modelPool.has(futureType, futureId)) {
                        return modelPool.get(futureType, futureId);
                    }
                    return func();
                }

                function get(config) {
                    return ensureCache(function () {
                        return processResponse($http.get(getRequestUrl(), getRequestConfig(config)));
                    });
                }

                function head(config) {
                    return ensureCache(function () {
                        return processResponse($http.head(getRequestUrl(), getRequestConfig(config)));
                    });
                }

                function post(data, config) {
                    return ensureCache(function () {
                        return saveAndTransform(data).then(function (model) {
                            return processResponse($http.post(getRequestUrl(), model, getRequestConfig(config)));
                        });
                    });
                }

                function put(data, config) {
                    return saveAndTransform(data).then(function (model) {
                        return processResponse($http.put(getRequestUrl(), model, getRequestConfig(config)));
                    });
                }

                function remove(config) {
                    return processResponse($http.delete(getRequestUrl(), getRequestConfig(config)));
                }

                function patch(data, config) {
                    return saveAndTransform(data).then(function (model) {
                        return processResponse($http.patch(getRequestUrl(), model, getRequestConfig(config)));
                    });
                }

                function save(model, config) {
                    if (model.isRepresentationModel) {
                        futureId = model.getId();
                        futureType = model.getType();
                        map(model);
                    }
                    return put(model, config);
                }

                /**
                 * Very custom method for search engine
                 * @param {Object} query query object
                 * @returns {!Promise} promise of search result
                 */
                function search(query) {
                    query = _.defaults(query || {}, {
                        where: "",
                        orderBy: "",
                        pageNumber: 0,
                        rowsPerPage: 10
                    });

                    var result = null;
                    return processResponse(
                        $http.post(getRequestUrl(), query, getRequestConfig(config))
                            .then(function (searchResults) {
                                if (searchResults && searchResults.data && searchResults.data.items) {
                                    result = searchResults.data;
                                    return {data: result.items};
                                }
                                return $q.reject("Empty search results!");
                            }
                        )).then(function (items) {
                            result.items = items;
                            return result;
                        });
                }

                //endregion

                //region Request processing

                function saveAndTransform(model) {
                    if (model && model.isRepresentationModel) {
                        return model.saveAndTransform();
                    }
                    return $q.when(model);
                }

                function processResponse(promise) {
                    promise = processErrors(promise);
                    promise = transformToModel(promise);
                    promise = processCache(promise);

                    return promise;
                }

                function processErrors(promise) {
                    return promise.then(function (resp) { //data, status, headers, config, statusText
                            if (!resp) {
                                return $q.reject("Unknown communication error");
                            }
                            return resp;
                        },
                        function (resp) {
                            var error = {};
                            if (resp) {
                                var msg = _.str.sprintf("Request to %s failed.", getRequestUrl());

                                error.status = resp.status;
                                error.statusText = resp.statusText;
                                if (resp.data) {
                                    error.serverErrorMessage = resp.data.ErrorMessage;
                                    error.serverFullException = resp.data.FullException;
                                    if (_.isString(resp.data)) {
                                        try { // parse HTML error page
                                            error.serverErrorMessage = $($.parseXML(resp.data))
                                                .find('body')
                                                .children() // get all `div` elements
                                                .map(function () {
                                                    return $(this).text();
                                                })
                                                .toArray()
                                                .join("\n");
                                        } catch (err) {
                                            // just ignore the exception...
                                        }
                                    }
                                }

                                if (error.status) {
                                    msg += " HTTP error " + error.status;
                                    if (error.statusText) {
                                        msg += ": " + error.statusText;
                                    }
                                    msg += ".";
                                } else {
                                    msg += " Server is not responding.";
                                }

                                if (error.serverErrorMessage) {
                                    msg += " Server error: " + error.serverErrorMessage + ".";
                                }

                                error.message = msg;
                            } else {
                                error.message = "Unknown error";
                            }

                            error.data = error;

                            $log.error(error.message);

                            return $q.reject(error);
                        });
                }

                function transformToModel(promise) {
                    if (!futureType) {
                        return promise.then(function (responce) {
                                if (responce) {
                                    return responce.data;
                                }
                                return responce;
                            }
                        );
                    }

                    return promise.then(function (responce) {
                        if (responce.data) {
                            if (_.isArray(responce.data)) {
                                var promises = [];
                                _.forEach(responce.data, function (obj) {
                                    var model = new RepresentationModel(getDefinition(futureType));
                                    promises.push(model.initAsync(obj));
                                });
                                return $q.all(promises);
                            } else {
                                var model = new RepresentationModel(getDefinition(futureType));
                                return model.initAsync(responce.data)
                            }
                        }
                        return responce.data;
                    });
                }

                function processCache(promise) {
                    if (!futureType) {
                        return promise;
                    }
                    return modelPool.promise(promise, futureType, futureId);
                }

                /**
                 * Get mapped request url
                 * @returns {string}
                 */
                function getRequestUrl() {
                    return _.compact(_.flatten([config.baseUrl, path, config.requestSuffix])).join("/");
                }

                /**
                 * Get united config for $http
                 * @param {Object.<string|Object>} currentConfig
                 * @returns {Object.<string|Object>}
                 */
                function getRequestConfig(currentConfig) {
                    currentConfig = currentConfig || {};
                    var headers = _.defaults({},
                        currentConfig.headers || {},
                        config.defaultHeaders || {},
                        (config.defaultHttpConfig && config.defaultHttpConfig.headers)
                            ? config.defaultHttpConfig.headers
                            : {}
                    );
                    var params = _.defaults({},
                        currentConfig.params || {},
                        config.defaultParams || {},
                        (config.defaultHttpConfig && config.defaultHttpConfig.params)
                            ? config.defaultHttpConfig.params
                            : {}
                    );

                    var cfg = _.defaults({}, config.defaultHttpConfig, currentConfig);
                    cfg.headers = headers;
                    cfg.params = params;

                    return cfg;
                }

                //endregion

                _.extend(_mapper, {
                    map: map,
                    willReturn: willReturn,

                    get: get,
                    head: head,
                    post: post,
                    put: put,
                    remove: remove,
                    patch: patch,
                    save: save,
                    search: search
                });
            }

            /**
             * Map request
             * @returns {RestService.RestMapper}
             */
            function map() {
                return new RestMapper(Array.prototype.slice.call(arguments));
            }

            function getDefinition(modelType) {
                return modelFactory.getDefinition(modelType);
            }

            /**
             * Create new model
             * @param {string} modelType model type
             * @param {Object} proto plain object for model
             * @returns {RepresentationModel} new model
             */
            function newModel(modelType, proto) {
                return new RepresentationModel(getDefinition(modelType), proto);
            }

            /**
             * Renew model from server
             * @param {string} modelType model type
             * @param {string|number} id model id
             * @param {number} [version] version of the model
             */
            function renewModel(modelType, id, version) {
                if (version && version > 0) {
                    return modelPool.get(modelType, id)
                        .then(function (model) {
                            if (model && model.$model.version >= version) {
                                return model;
                            }
                            return map(getDefinition(modelType)).map(id).willReturn(modelType).get();
                        }, function () {
                            return map(getDefinition(modelType)).map(id).willReturn(modelType).get();
                        });
                }
                return map(getDefinition(modelType)).map(id).willReturn(modelType).get();
            }

            /**
             * Check if rest engine tracking this model
             * @param {string} modelType
             * @param {string|number} id
             * @returns {boolean}
             */
            function hasModel(modelType, id) {
                if (!modelType || !id) {
                    return false;
                }
                return modelPool.has(modelType, id);
            }

            modelPool.events.on("modelUpdated", function (model) {
                _this.events.raise("modelUpdated", model);
            });

            function modelCreatedOnServer(modelInfo) {
                _this.events.raise("modelCreatedOnServer", modelInfo);
            }

            function modelUpdatedOnServer(modelInfo) {
                _this.events.raise("modelUpdatedOnServer", modelInfo);
            }

            _.extend(_this, {
                config: config,
                getDefinition: getDefinition,
                map: map,
                newModel: newModel,
                renewModel: renewModel,
                hasModel: hasModel,
                modelCreatedOnServer: modelCreatedOnServer,
                modelUpdatedOnServer: modelUpdatedOnServer
            });
        }

        return (RestService);
    })
;